/**
 * Bundle entry for the distributable widget (dist/widget/villamine-ai.js).
 * Exposes the module API and registers window.VillamineAI.mount for the
 * script-tag embed described in docs/05-EMBEDDING-CONTRACT.md.
 */
import { registerGlobal } from "./embed";

export * from "./index";

registerGlobal();
